import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Main from "./main";
import reportWebVitals from "./reportWebVitals";
import { GlobalProvider } from "./state/state";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

// Inter, self-hosted. See src/theme/typography.ts.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { UserProvider } from "./state/userState";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDXMWzKOGF-RyhHVeNG3DiF8cZxQKENKrk",
  authDomain: "plucky-sector-474519-m8.firebaseapp.com",
  projectId: "plucky-sector-474519-m8",
  storageBucket: "plucky-sector-474519-m8.firebasestorage.app",
  messagingSenderId: "256562055269",
  appId: "1:256562055269:web:17973b9ea37e9f8afede8c",
  measurementId: "G-XWE2EFKKH4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

root.render(
  <React.Suspense fallback={false}>
    <UserProvider>
      <GlobalProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ToastContainer toastClassName={"toast-container"} />
          <Main />
        </ThemeProvider>
      </GlobalProvider>
    </UserProvider>
  </React.Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
